import { create } from "zustand";
import { configurePersist } from "zustand-persist";
import { ValidationObj } from "../types/Grant";

const { persist: _persist } = configurePersist({
  rootKey: "root",
  storage: sessionStorage,
});

const persist = _persist as any;

export interface GrantImportResult {
  validationData: ValidationObj[][];
  hasErrors: boolean;
  message: string;
}

interface GrantImportStore {
  importResult: GrantImportResult | null;
  pendingAssignments: Record<string, string> | null;
  setImportResult: (result: GrantImportResult) => void;
  setPendingAssignments: (assignments: Record<string, string>) => void;
  clearImportResult: () => void;
}

export const useGrantImportStore = create<GrantImportStore>(
  persist(
    {
      key: "grantImportResult",
      name: "grantImportResult",
      storage: sessionStorage,
    },
    (set: any) => ({
      importResult: null,
      pendingAssignments: null,
      setImportResult: (result: GrantImportResult) =>
        set({ importResult: result }),
      setPendingAssignments: (assignments: Record<string, string>) =>
        set({ pendingAssignments: assignments }),
      clearImportResult: () =>
        set({ importResult: null, pendingAssignments: null }),
    })
  )
);
